export type { ImageProps, ImageSlots, ImageState, ImageBaseProps, ImageBaseState } from './components/Image/index';
export {
  Image,
  imageClassNames,
  renderImage_unstable,
  useImageStyles_unstable,
  useImage_unstable,
  useImageBase_unstable,
} from './components/Image/index';
